<div class="qualificates-theme">

  <div fxLayout="row" class="flexwrap">

    <div fxFlex="50" fxFlex.lt-md="100%">
      <mat-form-field class="campoFormulario">
        <mat-label>{{ 'protocolEdit.dialog.essay.essayType.label' | translate }}</mat-label>
        <mat-select name="data.essay.idType" [(ngModel)]="data.essay.idType"
          (selectionChange)="onChangeTypeSelect($event)" [disabled]="data.disabled">
          @for (item of essaysPossibles; track item) {
            <mat-option [value]="item.id">
              {{ 'essayType.' + item.translation | translate }}
            </mat-option>
          }
        </mat-select>
        <mat-error>
          {{ 'protocolEdit.dialog.essay.essayType.error' | translate }}
        </mat-error>
      </mat-form-field>
    </div>

    <div fxFlex="50" fxFlex.lt-md="100%">
      {{ 'protocolEdit.dialog.essay.variablesToUse.label' | translate }}:
      @for (item of variablesPossibles; track item; let i = $index) {
        <div>
          <mat-checkbox (change)="onChangeVariableCheck($event)" [value]="item"
            [disabled]="data.disabled || item.required" [checked]="isVariableChecked(item)">
            {{'variable.' + item.translation | translate }}
          </mat-checkbox>
        </div>
      }
    </div>

  </div>

  <div fxLayout="column">
    <div fxFlex="100%">
      <mat-form-field class="campoFormulario" style="width: 100%">
        <mat-label>{{ 'protocolEdit.essays.title.label' | translate }}</mat-label>
        <input matInput
          [(ngModel)]="data.essay.title" name="essayTitle">
      </mat-form-field>
    </div>
    <div fxFlex="100%">
      <mat-form-field class="campoFormulario" style="width: 100%">
        <mat-label>{{ 'protocolEdit.essays.additionalInfo' | translate }}</mat-label>
        <textarea rows="5" matAutosizeMinRows="5" matInput
        [(ngModel)]="data.essay.additionalInfo" name="additionalInfo" style="resize: none;"></textarea>
      </mat-form-field>
    </div>
    @if (showLoad()) {
      <div fxFlex="100%">
        <mat-form-field class="campoFormulario" style="width: 100%">
          <mat-label>{{ 'protocolEdit.essays.load.label' | translate }}</mat-label>
          <input matInput required
            [(ngModel)]="data.essay.load" name="load">
        </mat-form-field>
      </div>
    }
  </div>

  <mat-tab-group style="width: 100%;" (selectedTabChange)="onEssayTabChange($event)">

    @for (tab of data.essay.essayValues; track tab; let i = $index) {
      <mat-tab
        label="{{'variable.' + tab.translationVariable | translate }}" style="min-height: 50vh;">
        <mat-toolbar color="secondary">
          {{ 'protocolEdit.dialog.essay.fieldsTitle' | translate }}
        </mat-toolbar>
        <div fxLayout="row">
          <div fxFlex="33" fxFlex.lt-md="100%">
            <mat-form-field class="campoFormulario">
              <mat-label>{{ 'protocolEdit.dialog.essay.unit.label' | translate }}</mat-label>
              <mat-select name="unit{{tab.idVariable}}" [(ngModel)]="tab.idUnit" required
                (selectionChange)="onUnitChange(indexVariable, $event)"
                [disabled]="variableUnits?.length < 2">
                @for (item of variableUnits; track item) {
                  <mat-option [value]="item.id">
                    {{item.unit}}
                  </mat-option>
                }
              </mat-select>
              <mat-error>
                {{ 'protocolEdit.dialog.essay.unit.error' | translate }}
              </mat-error>
            </mat-form-field>
          </div>
        </div>
        <div fxLayout="row" class="flexwrap">
          @for (field of data.essay.essayValues[i].fields; track field; let indexField = $index) {
            <div fxFlex="50" fxFlex.lt-md="100%"
              >
              <!-- STRING -->
              @if (field.idTypeField == 1) {
                <div>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                    <input matInput
                      [name]="field.translationField" [(ngModel)]="field.value" [errorStateMatcher]="matcher"
                      (ngModelChange)="setValue(tab.idVariable, field, -1, $event)" [disabled]="data.disabled"
                      [required]="field.required">
                    <mat-error>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              }
              <!-- NUMÉRICO -->
              @if (field.idTypeField == 2) {
                <div>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                    <input matInput
                      [name]="field.translationField" [(ngModel)]="field.value" [errorStateMatcher]="matcher"
                      (ngModelChange)="setValue(tab.idVariable, field, -1, $event)" type="number" min="0"
                      [disabled]="data.disabled" [required]="field.required">
                    <mat-error>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              }
              <!-- TOLERANCIA -->
              @if (field.idTypeField == 3) {
                <div>
                  <div fxFlex="40%" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                      <input matInput
                        [name]="field.translationField" [(ngModel)]="field.value[0]"
                        (ngModelChange)="setValue(tab.idVariable, field, 0, $event)"
                        [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                        [required]="field.required">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="40%" fxFlex.lt-md="100%">
                    ±
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.valueTolerance.label' | translate }}</mat-label>
                      <input matInput
                        [name]="field.translationField + 'Tolerance'" [(ngModel)]="field.value[1]"
                        (ngModelChange)="setValue(tab.idVariable, field, 1, $event)"
                        [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                        [required]="field.required">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.valueTolerance.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                </div>
              }
              <!-- DIA HORA MIN -->
              @if (field.idTypeField == 4) {
                <div>
                  <div fxLayout="row">
                    <div fxFlex="34%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}: {{ 'common.days.label' | translate }}</mat-label>
                        <input matInput [name]="field.translationField + 'Day'" [(ngModel)]="field.value[0]"
                          (ngModelChange)="setValue(tab.idVariable, field, 0, $event)"
                          [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                          [required]="field.required" min="0">
                      </mat-form-field>
                    </div>
                    <div fxFlex="33%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'common.hours.label' | translate }}</mat-label>
                        <input matInput [name]="field.translationField + 'Hour'"
                          [(ngModel)]="field.value[1]"
                          (ngModelChange)="setValue(tab.idVariable, field, 1, $event)"
                          [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                          [required]="field.required" min="0">
                      </mat-form-field>
                    </div>
                    <div fxFlex="33%" fxFlex.lt-md="100%">
                      <mat-form-field class="campoFormulario">
                        <mat-label>{{ 'common.minutes.label' | translate }}</mat-label>
                        <input matInput [name]="field.translationField + 'Minute'"
                          [(ngModel)]="field.value[2]"
                          (ngModelChange)="setValue(tab.idVariable, field, 2, $event)"
                          [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                          [required]="field.required" min="0">
                      </mat-form-field>
                    </div>
                  </div>
                </div>
              }
              <!-- SELECT_ONE -->
              @if (field.idTypeField == 6) {
                <div>
                  <span>
                    {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                  </span>
                  <br />
                  <mat-radio-group class="vertical-radio-group" [required]="field.required">
                    @for (doma of field.fieldDomain; track doma) {
                      <mat-radio-button class="vertical-radio-button"
                        [value]="doma.value">
                        {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
                      </mat-radio-button>
                    }
                  </mat-radio-group>
                </div>
              }
              <!-- SELECT_MULTI -->
              @if (field.idTypeField == 7) {
                <div>
                  <span>
                    {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                    @if (field.required) {
                      <span>*</span>
                    }
                  </span>
                  <mat-selection-list [disabled]="data.disabled"
                    (selectionChange)="setValue(tab.idVariable, field, -1, $event)">
                    @for (doma of field.fieldDomain; track doma) {
                      <mat-list-option checkboxPosition="before"
                        [disabled]="data.disabled" [value]="doma.value"
                        [selected]="isSelectedMulti(field.value, doma.value)">
                        {{ 'protocolEdit.dialog.essay.' + doma.translation + '.label' | translate }}
                      </mat-list-option>
                    }
                  </mat-selection-list>
                </div>
              }
              <!-- BOOLEAN -->
              @if (field.idTypeField == 8) {
                <div>
                  <mat-checkbox [value]="field.value" [checked]="field.value == 'true'" [disabled]="data.disabled"
                    (change)="setValue(tab.idVariable, field, -1, $event)">
                    {{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}
                  </mat-checkbox>
                </div>
              }
              <!-- AREA -->
              @if (field.idTypeField == 9) {
                <div>
                  <mat-form-field class="campoFormulario">
                    <mat-label>{{ 'protocolEdit.dialog.essay.' + field.translationField + '.label' | translate }}</mat-label>
                    <textarea matInput [value]="field.value" [name]="field.translationField" rows="5"
                    (input)="setValue(tab.idVariable, field, 0, $event)" [required]="field.required"></textarea>
                    <mat-error>
                      {{ 'protocolEdit.dialog.essay.' + field.translationField + '.error' | translate }}
                    </mat-error>
                  </mat-form-field>
                </div>
              }
            </div>
          }
          @if (data.essay.essayValues[i].fields?.length == 0) {
            <div fxFlex="50" fxFlex.lt-md="100%"
              style="margin-top: 2em;margin-bottom: 2em;">
              {{ 'protocolEdit.dialog.essay.fields.empty' | translate }}
            </div>
          }
        </div>
        <mat-toolbar color="secondary">
          {{ 'protocolEdit.dialog.essay.criteriaTitle' | translate }}
          <button mat-icon-button color="accent" (click)="openNewCriteria(i)">
            <mat-icon>add</mat-icon>
          </button>
        </mat-toolbar>
        <div fxLayout="row" class="flexwrap">
          <div fxFlex>
            <table mat-table matSort #criteriaTable [dataSource]="data.essay.essayValues[i].criterias"
              style="width: 95%;">
              <!-- criteria Column -->
              <ng-container matColumnDef="criteria">
                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                  {{ 'protocolEdit.dialog.essay.criteria.cols.criteria' | translate }}
                </th>
                <td mat-cell *matCellDef="let item"> {{ showCriteria(item) }} </td>
              </ng-container>
              <!-- Button edit Column -->
              <ng-container matColumnDef="edit">
                <th mat-header-cell *matHeaderCellDef> {{ 'button.edit' | translate }} </th>
                <td mat-cell *matCellDef="let element; let criteriaIndex = index">
                  <button mat-icon-button (click)="editCriteria(i, criteriaIndex)">
                    <mat-icon>mode_edit</mat-icon>
                  </button>
                </td>
              </ng-container>
              <!-- Button delete Column -->
              <ng-container matColumnDef="delete">
                <th mat-header-cell *matHeaderCellDef> {{ 'button.delete' | translate }} </th>
                <td mat-cell *matCellDef="let element; let criteriaIndex = index">
                  <button mat-icon-button (click)="removeCriteria(i, criteriaIndex)">
                    <mat-icon>delete</mat-icon>
                  </button>
                </td>
              </ng-container>
              <tr mat-header-row *matHeaderRowDef="displayedColsCriteria"></tr>
              <tr mat-row *matRowDef="let row; columns: displayedColsCriteria;"></tr>
            </table>
          </div>
        </div>
        @if (showSensorsSection()) {
          <mat-toolbar color="secondary">
            {{ 'protocolEdit.dialog.essay.sensorsTitle' | translate }}
            @if (showSensorsSection() && showOptionalSensorsSection()) {
              <button mat-icon-button color="accent" (click)="openManualEditSensors(tab.idVariable)"
                >
                <mat-icon>format_list_numbered</mat-icon>
              </button>
            }
          </mat-toolbar>
        }
        @if (showOptionalSensorsCheck()) {
          <mat-checkbox (change)="onChangeCopySensorsCheck($event)"
            [value]="isCheckedCopySensors()" [checked]="isCheckedCopySensors()" [disabled]="data.disabled">
            {{ 'protocolEdit.dialog.essay.sensors.copy' | translate }}
          </mat-checkbox>
        }
        @if (showSensorsSection() && showOptionalSensorsSection()) {
          <div fxLayout="row" class="flexwrap">
            <div fxFlex="40" fxFlex.lt-md="100%">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolEdit.dialog.essay.sensors.numSensor.label' | translate }}</mat-label>
                <input matInput [name]="numSensor" [(ngModel)]="numSensor[tab.idVariable]" required
                  (ngModelChange)="setNumSensor(tab.idVariable, $event)" maxlength="2"
                  [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                  onkeypress="return event.charCode >= 48" min="1" max="99">
                <mat-error>
                  {{ 'protocolEdit.dialog.essay.sensors.numSensor.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="40">
              <mat-form-field class="campoFormulario">
                <mat-label>{{ 'protocolEdit.dialog.essay.criteria.percentSensorsCanFail.label' | translate }}</mat-label>
                <input matInput [name]="percentSensorsCanFail"
                  [(ngModel)]="data.essay.essayValues[i].percentSensorsCanFail" required
                  [errorStateMatcher]="matcher" type="number" [disabled]="data.disabled"
                  onkeypress="return event.charCode >= 48" min="0" max="99">
                <mat-error>
                  {{ 'protocolEdit.dialog.essay.criteria.percentSensorsCanFail.error' | translate }}
                </mat-error>
              </mat-form-field>
            </div>
            <div fxFlex="100%">
              @for (sensor of data.essay.essayValues[i].sensors; track sensor; let indexSensor = $index) {
                <div fxLayout="row" class="flexwrap"
                  >
                  <div fxFlex="20" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.sensors.sensorNum.label' | translate }}</mat-label>
                      <input matInput name="numSensor{{indexSensor}}" value="{{ indexSensor + 1 }}" disabled>
                    </mat-form-field>
                  </div>
                  <div fxFlex="50" fxFlex.lt-md="100%">
                    <mat-form-field class="campoFormulario">
                      <mat-label>{{ 'protocolEdit.dialog.essay.sensors.location.label' | translate }}</mat-label>
                      <input matInput name="numSensor{{indexSensor}}" [(ngModel)]="sensor.location"
                        [required]="!variableHasImage(data.essay.essayValues[i])"
                        [disabled]="data.disabled">
                      <mat-error>
                        {{ 'protocolEdit.dialog.essay.sensors.location.error' | translate }}
                      </mat-error>
                    </mat-form-field>
                  </div>
                  <div fxFlex="10" fxFlex.lt-md="100%">
                    <mat-checkbox [(ngModel)]="sensor.outer">{{ 'protocolEdit.dialog.essay.sensors.outer' | translate }}</mat-checkbox>
                  </div>
                  @if (sensor.hasBioindicator) {
                    <div fxFlex="10" fxFlex.lt-md="100%">
                      {{ 'protocolEdit.dialog.essay.sensors.bioStamp' | translate }}
                    </div>
                  }
                  @if (sensor.hasEndotoxin) {
                    <div fxFlex="10" fxFlex.lt-md="100%">
                      {{ 'protocolEdit.dialog.essay.sensors.endotoxinStamp' | translate }}
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        }
      </mat-tab>
    }
  </mat-tab-group>

</div>
<div mat-dialog-actions align="end" class="thermal-theme">
  @if (!data.disabled) {
    <button mat-raised-button color="primary" (click)="onOkClick()">
    {{ 'button.save' | translate }}</button>
  }
  <button mat-raised-button color="secondary" (click)="onNoClick()">{{ 'button.cancel' | translate }}</button>
</div>